import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, FileText } from 'lucide-react';
const contents = ["Fragrance-free vs unscented (and the words that don't protect you)", 'The Trigger Touchpoints Map (your house simplified)', 'Days 1–5: Laundry Reset (including residue + cross-contamination rules)', 'Days 6–10: Bath & Body Reset (the 3-product rule that lowers variables fast)', 'Days 11–14: Bedroom Reset (stuffed animal protocol + neutral sleep environment)', 'The Scent Bubble Plan (partners, grandparents, daycare—without fights)', 'The Flare-Up Playbook (environment-first, non-medical)'];
export function WhatsInside() {
  return <section className="py-20 px-6 bg-[#F9F9F9]" data-id="element-131">
      <div className="max-w-4xl mx-auto" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-133">
          <span className="inline-block p-3 bg-[#8B9D83]/10 rounded-full mb-4" data-id="element-134">
            <BookOpen className="w-6 h-6 text-[#8B9D83]" data-id="element-135" />
          </span>
          <h2 className="text-3xl md:text-4xl font-serif text-[#2D2D2D] mb-4" data-id="element-136">
            What's Inside
          </h2>
          <p className="text-[#5A5A5A]" data-id="element-137">A quick look at the ebook contents</p>
        </motion.div>

        <div className="bg-white rounded-2xl shadow-sm border border-[#E5E5E5] overflow-hidden" data-id="element-138">
          <div className="p-8 md:p-12" data-id="element-139">
            <ul className="space-y-6" data-id="element-140">
              {contents.map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.05
            }} className="flex items-start gap-4" data-id="element-141">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#F5F1E8] text-[#8B9D83] flex items-center justify-center text-xs font-bold mt-0.5" data-id="element-142">
                    {i + 1}
                  </span>
                  <span className="text-lg text-[#4A4A4A]" data-id="element-143">{item}</span>
                </motion.li>)}
            </ul>
          </div>
          <div className="bg-[#8B9D83]/10 p-6 flex items-center justify-center gap-3 text-[#5A5A5A] font-medium border-t border-[#8B9D83]/10" data-id="element-144">
            <FileText className="w-5 h-5 text-[#8B9D83]" data-id="element-145" />
            Plus printable checklists so you don't have to "remember" anything.
          </div>
        </div>
      </div>
    </section>;
}